const HOW_TO_USE_LINKS = {
  "code-distribution":
    "https://xoxoday.gitbook.io/plum/for-end-users/how-to-redeem#how-to-redeem-xoxo-codes",
  "link-distribution":
    "https://helpcenter.xoxoday.com/plum/user-guide/for-end-users/how-to-redeem#xoxo-link",
  "points-distribution":
    "https://xoxoday.gitbook.io/plum/for-end-users/how-to-redeem#xoxo-points",
};
export const getHowToUseLinks = (useCase = "") => {
  return HOW_TO_USE_LINKS[useCase] || null;
};
